import { useMemo } from 'react';
import {
  isUserWithEditorRole,
  isUserWithEventOrganizerRole,
} from 'utils/rolesUtils';
import { UserInfo } from 'services/api/user/userInfo';
import { EventResponse } from 'modules/events/models/interfaces';

export const useEventPermissions = (
  userInfo?: UserInfo | null,
  event?: EventResponse | null
) =>
  useMemo(() => {
    if (!userInfo) {
      return {
        isEditor: false,
        hasActiveEventOrganizerRole: false,
        currentUserExternalId: undefined,
        isOrganizerOfThisEvent: false,
        isEventExpired: false,
        canEditOrDeleteEvent: false,
      };
    }
    const isEditor = isUserWithEditorRole(userInfo);
    const hasActiveEventOrganizerRole = isUserWithEventOrganizerRole(userInfo);
    const currentUserExternalId = userInfo.externalId;
    const isOrganizerOfThisEvent = Boolean(
      event?.organizers?.some((org) => org.externalId === currentUserExternalId)
    );

    const isEventExpired = (() => {
      if (!event?.plannedEndDate) return false;
      const cutoffDate = new Date();
      cutoffDate.setDate(cutoffDate.getDate() - 90);
      const eventEndDate = new Date(event.plannedEndDate);
      return eventEndDate < cutoffDate;
    })();

    const canEditOrDeleteEvent =
      isEditor ||
      (hasActiveEventOrganizerRole &&
        isOrganizerOfThisEvent &&
        !isEventExpired);

    return {
      isEditor,
      hasActiveEventOrganizerRole,
      currentUserExternalId,
      isOrganizerOfThisEvent,
      isEventExpired,
      canEditOrDeleteEvent,
    };
  }, [userInfo, event]);
